import blogGIF from '../assets/blogGIF.gif';
import fantasyGIF from '../assets/fantasyGIF.gif';
import HLogin from '../assets/heronLogin.gif';
import HFriends from '../assets/heronFriends.gif';
import HGlobal from '../assets/heronGlobal.gif';
import shoppingGIF from '../assets/shoppingGIF.gif';
import waldoGIF from '../assets/waldoGIF.gif';
import memoryGIF from '../assets/memoryGIF.gif';
import cvGif from '../assets/cvGIF.gif';
import battleshipGIF from '../assets/battleGIF.gif';
import membersGIF from '../assets/membersOnly.gif';
import knightGIF from '../assets/knightTravails.gif';
import weatherGIF from '../assets/weatherapp.gif';
import todoGIF from '../assets/todo.gif';
import restGIF from '../assets/restaurant.gif';
import ticGIF from '../assets/tictak.gif';

export const topspheresConfig = [
  {
    id: 'blog',
    originName: 'Blog',
    name: 'md:text-5xl text-5xl text-white ',
    mainColor: 'before:bg-gray-900',
    innerTitle: 'Blog',
    header: 'text-white text-xl md:text-4xl',
    tools: 'text-rose-500  text-[10px] md:text-lg ',
    toolContent: 'Express Taiwlind NextJS',
    src: blogGIF,
    livelink: 'https://kiwasthal-blog.vercel.app/',
    desc: 'Blog webb aplication gif',
    paraStyles: 'text-white text-[10px] leading-3 md:leading-5 md:text-lg',
    para: 'A site for blogging, consisting of three parts. A node Api deployed on heroku. A cms for updating content utalizing admin login and a client built with nextjs.',
    button: 'text-white  bg-rose-500 ',
    multiple: false,
  },
  {
    id: 'f-inventory',
    originName: 'Fantasy Inventory',
    name: 'text-4xl text-white',
    mainColor: 'before:bg-stone-900',
    innerTitle: 'Fantasy Inventory ',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-rose-500 text-[9px] md:text-lg',
    toolContent: 'Express Taiwlind MongoDB',
    src: fantasyGIF,
    livelink: 'https://infinite-mesa-17935.herokuapp.com/archieve',
    desc: 'Blog webb aplication gif',
    paraStyles: 'text-white text-[11px] leading-3 md:leading-5 md:text-lg ',
    para: 'An inventory application for cataloguing fantastical creatures. Rendering handled by EJS, and back-end build with ExpressJS and Mongoose.',
    button: 'text-white  bg-rose-500 ',
    mutiple: false,
  },
  {
    id: 'messanger',
    originName: 'Heron Messenger',
    name: 'text-3xl text-white ',
    mainColor: 'before:bg-fuchsia-500',
    innerTitle: 'Heron Messanger ',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-gray-900 text-[9px] md:text-lg',
    toolContent: 'Redux,Firebase,Typescript',
    src: null,
    livelink: 'https://heron-messaging.web.app/',
    desc: 'Messanger app browsing features',
    paraStyles: 'text-white text-[11px] leading-3 md:leading-5 md:text-lg',
    para: 'A real-time messanger application built with firebase and redux-toolkit. State managed primarily by redux and the app is constructed and linted with typescript rules.',
    button: 'text-white  bg-gray-900 ',
    multiple: true,
    multipleVariants: [HLogin, HFriends, HGlobal],
  },
  {
    id: 'waldo',
    originName: 'Where is Waldo?',
    name: 'text-4xl text-white ',
    mainColor: 'before:bg-red-700',
    innerTitle: 'Find Waldo',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-zinc-900 text-[9px] md:text-lg',
    toolContent: 'React,Firebase',
    src: waldoGIF,
    livelink: 'https://photo-tagging-app-b3072.firebaseapp.com/',
    desc: 'Where is waldo game',
    paraStyles: 'text-white text-[11px] leading-3 md:leading-5 md:text-lg',
    para: 'A react application utilizing firebase service back-end to catalogue different times set by users playing the infamous where-is-waldo picture searching game.',
    button: 'text-white  bg-zinc-900 ',
    multiple: false,
    multipleVariants: [],
  },
  {
    id: 'shop',
    originName: 'Fantasy Shop',
    name: 'text-4xl text-white ',
    mainColor: 'before:bg-red-900',
    innerTitle: 'Fantasy Shop',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-rose-500 text-[9px] md:text-lg',
    toolContent: 'React',
    src: shoppingGIF,
    livelink: 'https://kiwasthal.github.io/shopping-cart/',
    desc: 'Shopping application',
    paraStyles: 'text-white text-[11px] leading-3 md:leading-5 md:text-lg',
    para: 'An application making use of Gutendex-api to fetch various information on books simulating the shopping exprerience of such websites.',
    button: 'text-white  bg-rose-500 ',
    multiple: false,
    multipleVariants: [],
  },
  {
    id: 'memory',
    originName: 'Memory Game',
    name: 'text-4xl text-white ',
    mainColor: 'before:bg-green-600 ',
    innerTitle: 'Memory Game',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-rose-500 text-[9px] md:text-lg',
    toolContent: 'React',
    src: memoryGIF,
    livelink: 'https://kiwasthal.github.io/memory-card/',
    desc: 'Application of a memory game using pokemon (gif).',
    paraStyles: 'text-white text-[11px] leading-3 md:leading-5 md:text-lg',
    para: "Creating a memory game that can track the user's score along with their highest-score. The app rerenders and makes request corresponding to user's performance.",
    button: 'text-white  bg-rose-500 ',
    multiple: false,
    multipleVariants: [],
  },
  {
    id: 'cv',
    originName: 'CV Application',
    name: 'text-3xl text-white ',
    mainColor: 'before:bg-orange-500',
    innerTitle: 'CV Builder',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-gray-700 text-[9px] md:text-lg',
    toolContent: 'React',
    src: cvGif,
    livelink: 'https://kiwasthal.github.io/cv-app-revisited/',
    desc: 'CV builder application',
    paraStyles: 'text-white text-[11px] leading-3 md:leading-5 md:text-lg',
    para: 'An interactive cv-building application created as react practice on  hooks. The user can add and update all fields with his preferred information.',
    button: 'text-white  bg-gray-700 ',
    multiple: false,
    multipleVariants: [],
  },
  {
    id: 'battleship',
    originName: 'Battleship',
    name: 'text-3xl text-white ',
    mainColor: 'before:bg-neutral-700',
    innerTitle: 'Battleship',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-rose-500 text-[9px] md:text-lg',
    toolContent: 'Vanilla Javascript',
    src: battleshipGIF,
    livelink: 'https://kiwasthal.github.io/battleship/',
    desc: 'Battleship game',
    paraStyles: 'text-white text-[11px] leading-3 md:leading-5 md:text-lg',
    para: 'Simulating the battleship board game using vanilla javascript. Players take turns trying to destroy their opponents ships. First to destroy five ships wins the game.',
    button: 'text-white  bg-rose-500 ',
    multiple: false,
    multipleVariants: [],
  },
  {
    id: 'members_only',
    originName: 'Members Only',
    name: 'text-4xl text-white ',
    mainColor: 'before:bg-gray-900',
    innerTitle: 'Members Only',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-rose-500 text-[9px] md:text-lg',
    toolContent: 'Express,Tailwind,EJS',
    src: membersGIF,
    livelink: 'https://kiwasthal-members-only.herokuapp.com/messages',
    desc: 'Members only website',
    paraStyles: 'text-white text-[10px] leading-2 md:leading-5 md:text-lg',
    para: 'An express application with passport authentication. Logged users can view authors and times, while anonymous users cannot view all relevant information about posts.',
    button: 'text-white  bg-rose-500 ',
    multiple: false,
    multipleVariants: [],
  },
  {
    id: 'knight',
    originName: 'Knight Travails',
    name: 'text-4xl text-white ',
    mainColor: 'before:bg-stone-700',
    innerTitle: 'Knight Travails',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-rose-500 text-[9px] md:text-lg',
    toolContent: 'Vanilla Javascript',
    src: knightGIF,
    livelink: 'https://kiwasthal.github.io/Knight-travails/',
    desc: 'Knight travails web-showcase',
    paraStyles: 'text-white text-[10px] leading-3 md:leading-5 md:text-lg',
    para: "A visual representation of a knight's travels.Picking starting and ending coords revealing the shortest path the piece can take to the destination.",
    button: 'text-white  bg-rose-500 ',
    multiple: false,
    multipleVariants: [],
  },
  {
    id: 'weather',
    originName: 'Weather Application',
    name: 'text-3xl text-white ',
    mainColor: 'before:bg-yellow-600',
    innerTitle: 'Weather Application',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-rose-500 text-[9px] md:text-lg',
    toolContent: 'Vanilla Javascript',
    src: weatherGIF,
    livelink: 'https://kiwasthal.github.io/weather-app/',
    desc: 'Weather application website',
    paraStyles: 'text-white text-[11px] leading-3 md:leading-5 md:text-lg',
    para: 'App making use of OpenWeather API to get the meteorological prediciton of the incoming week for the city searched. ',
    button: 'text-white  bg-rose-500 ',
    multiple: false,
    multipleVariants: [],
  },
  {
    id: 'todo',
    originName: 'Todo List',
    name: 'text-3xl text-white ',
    mainColor: 'before:bg-cyan-800',
    innerTitle: 'Todo List',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-rose-500 text-[9px] md:text-lg',
    toolContent: 'Vanilla Javascript',
    src: todoGIF,
    livelink: 'https://kiwasthal.github.io/todo-list/',
    desc: 'Task Application website',
    paraStyles: 'text-white text-[11px] leading-3 md:leading-5 md:text-lg',
    para: 'A Javascript application to create project sections and register different tasks. Tasks are saved on the local storage. ',
    button: 'text-white  bg-rose-500 ',
    multiple: false,
    multipleVariants: [],
  },
  {
    id: 'restaurant',
    originName: 'Restaurant Page',
    name: 'text-3xl text-white ',
    mainColor: 'before:bg-orange-400',
    innerTitle: 'Restaurant Page',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-rose-500 text-[9px] md:text-lg',
    toolContent: 'Vanilla Javascript',
    src: restGIF,
    livelink: 'https://kiwasthal.github.io/restaurant-page/',
    desc: 'Restaurant Page website',
    paraStyles: 'text-white text-[11px] leading-3 md:leading-5 md:text-lg',
    para: 'Creating a web-page for a restaurant.Pages are updated while rebuilding the node tree with vanilla javascript immitating proper routing.',
    button: 'text-white  bg-rose-500 ',
    multiple: false,
    multipleVariants: [],
  },
  {
    id: 'tic-tac',
    originName: 'Tic-Tac-Toe',
    name: 'text-3xl text-white ',
    mainColor: 'before:bg-orange-700',
    innerTitle: 'Tic-Tac-Toe',
    header: 'text-white text-lg md:text-4xl',
    tools: 'text-stone-800 text-[9px] md:text-lg',
    toolContent: 'Vanilla Javascript',
    src: ticGIF,
    livelink: 'https://kiwasthal.github.io/tic-tac-toe/',
    desc: 'Tic-tac-toe game',
    paraStyles: 'text-white text-[11px] leading-3 md:leading-5 md:text-lg',
    para: 'Recreating the infamous tic-tac-toe Game.Users can challenge each other in a match, or play against a min-maxed AI',
    button: 'text-white  bg-stone-800 ',
    multiple: false,
    multipleVariants: [],
  },
];
